export const T = {
  nav: "nav",
  navToggle: "nav-mobile-toggle",
  navMobileMenu: "nav-mobile-menu",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",
  marquee: "marquee",
  featuredBook: "featured-book",
  bookCard: (slug) => `book-card-${slug}`,
  bookLink: (slug) => `book-details-link-${slug}`,
  buyAmazonCom: (slug) => `buy-amazon-com-${slug}`,
  buyAmazonCa: (slug) => `buy-amazon-ca-${slug}`,
  booksySampleLink: (slug) => `booksy-sample-link-${slug}`,
  trilogySection: "trilogy-section",
  manifestoSection: "manifesto-section",
  newsletterEmail: "newsletter-email-input",
  newsletterSubmit: "newsletter-submit-button",
  newsletterSuccess: "newsletter-success-note",
  newsletterError: "newsletter-error-note",
  newsletterHoneypot: "newsletter-honeypot",
  contactName: "contact-name-input",
  contactEmail: "contact-email-input",
  contactMessage: "contact-message-input",
  contactSubmit: "contact-submit-button",
  contactSuccess: "contact-success-note",
  contactHoneypot: "contact-honeypot",
  confirmState: "subscribe-confirm-state",
  unsubscribeState: "unsubscribe-state",
  footer: "footer",
};

export const HOME = { emergentLink: "home-emergent-link" };
